import { render, staticRenderFns } from "./Tab3DrugRecords.vue?vue&type=template&id=05a46056&scoped=true&"
import script from "./Tab3DrugRecords.vue?vue&type=script&lang=js&"
export * from "./Tab3DrugRecords.vue?vue&type=script&lang=js&"
import style0 from "./Tab3DrugRecords.vue?vue&type=style&index=0&id=05a46056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a46056",
  null
  
)

export default component.exports